module.exports = __webpack_public_path__ + "static/media/pause-icon.312cc322.svg";